import Landing from './landing.js';
import Main from './main.js';
import Steps from './steps.js';
import Certifications from './certifications.js';
import SkillsAndLanguages from './skillsAndLanguages.js';
import WorkHistory from './workHistory.js';
import Personality from './personality.js';
import WorkAvailability from './workAvailability.js';
import TravelPreferences from './travelPreferences.js';
import WorkEligibility from './workEligibility.js';
import Contact from './contact.js';
import Agreements from './agreements.js';
import Confirm from './confirm.js';
import Interview from './interview.js';
import SummaryCard from './summaryCard.js';
import InterviewQuestions from './interviewQuestions.js';

export default {
  Landing,
  Main,
  Steps,
  Certifications,
  SkillsAndLanguages,
  WorkHistory,
  Personality,
  WorkAvailability,
  TravelPreferences,
  WorkEligibility,
  Contact,
  Agreements,
  Confirm,
  Interview,
  SummaryCard,
  InterviewQuestions,
};
